import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { companyInfo, navLinks, logoImage } from "../mock/mock";

export default function Footer() {
  return (
    <footer className="bg-[#08080a] border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src={logoImage}
              alt="Ortiz Truck & Landscaping LLC"
              className="h-16 w-auto object-contain"
            />
            <div className="leading-tight">
              <div className="font-display font-bold text-[17px] text-[#f4efe6]">
                {companyInfo.name}
              </div>
              <div className="text-[10.5px] tracking-[0.22em] text-[#8a877f] font-medium">
                {companyInfo.tagline}
              </div>
            </div>
          </div>
          <p className="mt-5 text-[13.5px] leading-relaxed text-[#8a877f] max-w-md">
            Locally owned and proudly serving the Magic Valley with reliable
            hauling, material delivery, demolition debris removal, and
            dependable dump truck services.
          </p>
        </div>

        <div>
          <div className="text-[10.5px] uppercase tracking-[0.22em] text-[#c9b98a] font-semibold mb-4">
            Navigate
          </div>
          <ul className="space-y-2.5">
            {navLinks.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  className="text-[13px] text-[#c8c5bc] hover:text-white"
                >
                  {l.label.charAt(0) + l.label.slice(1).toLowerCase()}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="text-[10.5px] uppercase tracking-[0.22em] text-[#c9b98a] font-semibold mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-[13px] text-[#c8c5bc]">
            <li className="flex items-start gap-2">
              <Phone size={13} className="mt-1 text-[#8a877f]" />
              <a href={`tel:${companyInfo.phone}`} className="hover:text-white">
                {companyInfo.phone}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={13} className="mt-1 text-[#8a877f]" />
              <a
                href={`mailto:${companyInfo.email}`}
                className="hover:text-white break-all"
              >
                {companyInfo.email}
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={13} className="mt-1 text-[#8a877f]" />
              <span>{companyInfo.location}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/[0.06]">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-[12px] text-[#8a877f]">
          <div>
            © {new Date().getFullYear()} {companyInfo.name}. All rights
            reserved.
          </div>
          <div className="tracking-[0.16em] uppercase">
            Magic Valley Hauling • Idaho
          </div>
        </div>
      </div>
    </footer>
  );
}
